import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scoreConversionPipe'
})
export class ScoreConversionPipe implements PipeTransform {
  transform(value: any): any {
    if (value != null && value !== ''){
      value = value.replace('.', '');
      value = value.replace(',', '');
      // tslint:disable-next-line: radix
      if ( parseInt(value) > 10) {
        value = value.slice(0, 1) + '.' + value.slice(1);
      // tslint:disable-next-line: radix
      }else if (parseInt(value.slice(0, 1)) === 0){
        value = value.slice(0, 1) + '.' + value.slice(1);
      // tslint:disable-next-line: radix
      }
      return value;
    }

    // tslint:disable-next-line: radix
    return value;
  }

}
